import React, { useState } from 'react';
import { useAnimationOnScroll } from '../hooks/useAnimations';
import TimelineYears from './TimelineYears';
import { tournamentData, getYearSummary } from '../data/tournaments';
import '../styles/components/Timeline.scss';

const Timeline = () => {
    const { ref, inView } = useAnimationOnScroll({
        threshold: 0.1,
        triggerOnce: true
    });

    // Start with all years displayed
    const years = Object.keys(tournamentData);
    const allTournaments = [];
    
    // Collect all tournaments with their years
    years.forEach(year => {
        tournamentData[year].forEach(tournament => {
            allTournaments.push({
                ...tournament,
                year
            });
        });
    });
    
    // Sort by date (assume date is in format "Month YYYY")
    allTournaments.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateA - dateB;
    });

    return (
        <section id="timeline" className="timeline-section">
            <div className="section-container" ref={ref}>
                <h2 className={`section-title ${inView ? 'fade-in' : ''}`} style={{ color: '#4AA9FF' }}>
                    {"'Zafer, zafer benimdir diyebilenindir. Başarı ise 'başaracağım' diye başlayarak sonunda 'başardım' diyenindir.'"}
                </h2>

                <div className={`timeline-container ${inView ? 'slide-up' : ''}`}>
                    <div className="tournaments-container">
                        <div className="tournaments-grid">
                            {allTournaments.map((tournament, index) => (
                                <div key={index} className="tournament-item">
                                    <div className="timeline-marker"></div>
                                    <div className="tournament-date">{tournament.date}</div>
                                    <div className="tournament-content">
                                        <div className="tournament-icon">
                                            <img src={`/assets/images/${tournament.logo}`} alt={tournament.title} className="tournament-logo" />
                                        </div>
                                        <div className="tournament-details">
                                            <h4>{tournament.title}</h4>
                                            <p className="placement">{tournament.placement}</p>
                                            <p className="description">{tournament.description}</p>
                                            <img src={`/assets/images/${tournament.result}`} alt={tournament.title} className="tournament-logo" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* <div className="timeline-vision">
                        
                        <p>
                            Yıllar içinde edindiğimiz tecrübe ve başarılarla, e-spor dünyasında Türkiye'yi en iyi şekilde temsil etmeye devam ediyoruz.
                        </p>
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default Timeline;